import MentorTipsPopup from './MentorTipsPopup';

export default MentorTipsPopup;
